<div class="container">
  <!-- Header -->
  <div class="header">Create Wallet</div>

  <form [formGroup]="walletForm" (ngSubmit)="onSubmit()">
    <!-- Form Fields -->
    <div class="input-container">
      <div class="form-field">
        <app-dropdown
          label="Type of Wallet"
          placeholder="Select wallet type"
          [options]="walletTypeOptions"
          formControlName="walletType"
          [isInvalid]="getFieldError('walletType', 'Wallet type') !== ''"
          [errorMessage]="getFieldError('walletType', 'Wallet type')"
        ></app-dropdown>
      </div>

      @if (shouldShowSystemWalletType) {
        <div class="form-field">
          <app-dropdown
            label="System Wallet Type"
            placeholder="Select system wallet type"
            [options]="systemWalletTypeOptions"
            formControlName="systemWalletType"
            [isInvalid]="getFieldError('systemWalletType', 'System wallet type') !== ''"
            [errorMessage]="getFieldError('systemWalletType', 'System wallet type')"
          ></app-dropdown>
        </div>
      }

      <div class="form-field">
        <app-dropdown
          label="Blockchain"
          placeholder="Select blockchain"
          [options]="blockchainOptions()"
          formControlName="addressFamily"
          [isInvalid]="walletForm.get('addressFamily')?.value !== ''"
          [errorMessage]="metadata.error() || getFieldError('addressFamily', 'Blockchain')"
          [iconPath]="getNetworkIcon()"
        ></app-dropdown>
      </div>

      <div class="form-field">
        <app-text-input
          placeholder="Wallet name"
          [label]="'Wallet Name'"
          formControlName="name"
          [isInvalid]="getFieldError('name', 'Wallet name') !== ''"
          [errorMessage]="getFieldError('name', 'Wallet name')"
        ></app-text-input>
      </div>
    </div>

    <!-- Buttons -->
    <div class="buttons">
      <app-button buttonVariant="dialog-secondary" buttonType="button" (buttonClick)="onCancel()">Cancel</app-button>
      <app-button buttonVariant="dialog-primary" buttonType="submit" [state]="nextButtonState">
        Next
      </app-button>
    </div>
  </form>
</div>
